// @ts-nocheck
import store from "store"; // ✅ 改为 ESM 导入
/**
 * 存储前缀
 */
const StorePrefix = "MFKSoft_";

export default {
    /**
     * 存储关键字
     */
    StoreKey: {
        Token: `${StorePrefix}Token`,
        User: `${StorePrefix}User`,
        UserInfo: `${StorePrefix}UserInfo`,
        LoginFailures: `${StorePrefix}LoginFailures`,
        Platform: `${StorePrefix}Platform`,
        MchFunctions: `${StorePrefix}MchFunctions`,
        MchID: `${StorePrefix}MchID`,
        GetMchInfoKey: function (mchID: number) {
            return `${StorePrefix}MchInfo_${mchID}`;
        }
    },
    /**
     * 存储Token值
     * @param {string} val Token值
     */
    SetToken(val: string) {
        store.set(this.StoreKey.Token, val);
    },
    /**
     * 获取当前存储的Token值
     */
    GetToken() {
        return store.get(this.StoreKey.Token);
    },
    /**
     * 移除Token存储
     */
    RemoveToken() {
        store.remove(this.StoreKey.Token);
    },
    /**
     * 存储当前用户编号值
     * @param {string} val 用户编号
     */
    SetUserID(val: string) {
        store.set(this.StoreKey.User, val);
    },
    /**
     * 获取当前存储的用户编号
     */
    GetUserID() {
        return store.get(this.StoreKey.User);
    },
    /**
     * 移除当前存储的用户编号值
     */
    RemoveUserID() {
        store.remove(this.StoreKey.User);
    },
    /**
     * 存储当前用户信息
     * @param {string} val 用户信息
     */
    SetUserInfo(val: any) {
        store.set(this.StoreKey.UserInfo, val);
    },
    /**
     * 获取当前存储的用户信息
     */
    GetUserInfo() {
        return store.get(this.StoreKey.UserInfo);
    },
    /**
     * 移除当前用户信息
     */
    RemoveUserInfo() {
        store.remove(this.StoreKey.UserInfo);
    },
    // 是否登录失败次数
    GetLoginFailures(): number {
        const result = store.get(this.StoreKey.LoginFailures);
        if (result)
            return parseInt(result);
        return 0;
    },
    //存储登录失败次数
    SetLoginFailures(val: number) {
        store.set(this.StoreKey.LoginFailures, val,)
    },
    //移除登录失败次数
    RemoveLoginFailures() {
        store.remove(this.StoreKey.LoginFailures,)
    },
    //设置当前所在平台
    SetPlatform(platform: number) {
        store.set(this.StoreKey.Platform, platform,)
    },
    //取得当前平台类型
    GetPlatform(): number {
        let platform = 0;
        const result = store.get(this.StoreKey.Platform);
        if (result) {
            platform = parseInt(result);
        }
        return platform;
    },

    /**
     * 获取当前商户编号
     */
    GetMchID() {
        const result = store.get(this.StoreKey.MchID);
        if (result)
            return parseInt(result);
        return 0;
    },
    ChangeMchID(mchID: number): boolean {
        console.log("切换商户编号:" + mchID);
        store.set(this.StoreKey.MchID, mchID,)
        return true;
    },
    /**
     * 获取当前存储的商户信息
     * @param mchID
     */
    GetMchCompData(mchID?: number): any {
        const result = store.get(this.StoreKey.GetMchInfoKey(mchID ? mchID : this.GetMchID()));
        if (result) {
            return result;
        }
        return undefined;
    },
    /**
     * 移除当前商户信息
     */
    RemoveMchCompData() {
        store.remove(this.StoreKey.GetMchInfoKey(this.GetMchID()))
    },
    /**
     * 存储当前商户信息
     * @param {string} val 商户信息
     */
    SetMchCompData(val: any) {
        console.log("存储当前商户信息", val);
        if (val && val.Merchant) {
            store.set(this.StoreKey.MchID, val.Merchant.MchID,)
        }
        store.set(this.StoreKey.GetMchInfoKey(val.MchID), val)
    },
    /**
     * 获取当前存储的商户功能
     */
    GetMyMchFunctions() {
        const result = store.get(this.StoreKey.MchFunctions);
        if (result) {
            return result;
        }
        return undefined;
    },
    /**
     * 存储当前商户功能
     * @param {string} val 商户功能
     */
    SetMyMchFunctions(val: any) {
        store.set(this.StoreKey.MchFunctions, val)
    },
    /**
     * 移除当前商户功能
     */
    RemoveMyMchFunctions() {
        store.remove(this.StoreKey.MchFunctions)
    },
    //设置自定义数据
    SetCustomData(key: string, val: any): void {
        store.set(key, val)
    },
    //获取自定义数据
    GetCustomData(key: string): any {
        return store.get(key)
    },
    //移除自定义数据
    RemoveCustomData(key: string): void {
        store.remove(key)
    }
}
